import type { Logger } from '@vp/ubik-logging'

import { insertWork } from '../clients/WorkEntityClient'
import type { PostDocumentResponse } from '../types/UdsDocument'
import type { NewWork } from '../types/Work'
import type { WorkId } from '../types/WorkId'

export const DefaultEditUrlPath = '/studio/'

export const getEditUrlPathFromUrl = (existingEditUrl: string) => {
  let editUrl = DefaultEditUrlPath
  const re = /(?<path>\/.*)\?workId=/
  const found = existingEditUrl.match(re)
  if (found && found.groups && found.groups['path']) {
    editUrl = found.groups['path']
  }
  return editUrl
}

export const createAndSaveWork = async (
  cartTenant: string,
  productName: string,
  editUrlPath: string,
  postDocResponse: PostDocumentResponse,
  ownerId: string,
  productKey: string,
  productVersion: number,
  mpvTenant: string,
  culture: string,
  mpvId: string,
  selectedOptions: Record<string, string>,
  minimumOrderQuantity: number,
  isSizedGood: boolean,
  isCareAgent: boolean,
  authorizationHeader: string,
  logger: Logger,
): Promise<WorkId> => {
  const newWork: NewWork = {
    workName: productName,
    design: {
      editUrl: `${editUrlPath}?workId=\${workId}`,
      designUrl: postDocResponse._links.documentRevision.href,
      displayUrl: postDocResponse._links.previewInstructions.href,
      manufactureUrl: postDocResponse._links.drawingInstructions.href,
      docRefUrl: postDocResponse._links.documentReference.href,
      metadata: {
        udsDocumentUrl: postDocResponse._links.self.href,
      },
    },
    ownerId: ownerId,
    product: {
      key: productKey,
      version: productVersion.toString(),
    },
    merchandising: {
      mpvUrl: `https://merchandising-product-service.cdn.vpsvc.com/api/v3/mpv/${mpvTenant}/${culture}/${mpvId}`,
      merchandisingSelections: selectedOptions,
      quantity: minimumOrderQuantity, // TODO : is this correct for all cases?
    },
    resources: {
      mpvId: mpvId,
      productKey: productKey,
      isSizedGood: `${isSizedGood}`,
      isHardGood: `${!isSizedGood}`,
      qty: isSizedGood ? '{}' : '0',
    },
  }

  const savedWork = await insertWork(cartTenant, newWork, isCareAgent, newWork.ownerId, authorizationHeader, logger)

  return savedWork.workId
}
